export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferir"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferencia entre cuentas propias"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferencias dentro de la billetera"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Las cuentas de remitente y destinatario deben ser diferentes"])}
}